import React from 'react';
import styled from 'styled-components/macro';

import { theme } from '../../theme';
import { personNoBg } from '../../assets';
import { useKennoTenant } from '../../context/kennoTenantContext';
import YSaatioLogo from './YSaatioLogo';
import LocalizationButtons from '../../components/header/LocalizationButtons';
import { DeviceSize } from '../../components/basic/DeviceSize';
import { Body2, Button } from '../../components/common';
import { FlexRow } from '../../components/basic/Flex';
import { useLogout } from '../../hooks/useLogout';
import { useMessageGetter } from 'react-message-context';

const YSaatioHeader: React.FC = () => {
  const [{ user }] = useKennoTenant();
  const { logout } = useLogout();
  const t = useMessageGetter('common');

  return (
    <header>
      <NaviWrapper justifyContent="center" alignItems="center">
        <MainNaviHeader>
          <YSaatioLogo />
          <FlexRow justifyContent="end">
            <LocalizationButtons />
            <FlexRow justifyContent="center" alignItems="center" gap="16px">
              <img alt="" height="16px" width="16px" src={personNoBg} />
              <Body2>{`${user.attributes?.firstName} ${user.attributes?.lastName}`}</Body2>
              <Button onClick={logout} size="medium">
                {t('signOut')}
              </Button>
            </FlexRow>
          </FlexRow>
        </MainNaviHeader>
      </NaviWrapper>
    </header>
  );
};

const NaviWrapper = styled(FlexRow)`
  border-bottom: 1px solid ${theme().colors.m2Black};
`;

const MainNaviHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1256px;
  padding: 24px;

  @media ${DeviceSize.desktopS} {
    flex-direction: column;
    gap: 24px;
  }
`;

export default YSaatioHeader;
